import { alpha, darken, Stack, useTheme } from "@mui/material";

interface TooltipChartsProps {
  color: string;
  valueX: string | number;
  valueY?: string | number;
  valueZ: string | number;
}
function TooltipCharts({ color, valueX, valueY, valueZ }: TooltipChartsProps) {
  const theme = useTheme();
  const styles = {
    container: {
      padding: "8px",
      color: theme.palette.text.primary,
      background: alpha(theme.palette.background.default, 0.9),
      backdropFilter: "blur(11px)",
      borderRadius: 4,
      fontSize: "0.875rem",
      textAlign: "center" as const,
      justifyContent: "center",
      alignItems: "center",
      gap: 8,
      width: "fit-content",
      height: "fit-content",
      display: "flex",
      flexDirection: "row" as const,
    },
    dot: {
      width: "12px",
      height: "12px",
      backgroundColor: color,
      borderRadius: "50%",
      border: color && `1px solid ${darken(color as string, 0.2)}`,
      flexShrink: 0,
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.dot} />
      {valueX} {valueY ? " - " + valueY : ""}:{" "}
      <span style={{ fontWeight: 700 }}>{valueZ}</span>
    </div>
  );
}
export default TooltipCharts;
